import { RootState } from '../index';
import { Site, StoreStatus } from '../../core/types/common.types';

export const errorSelector = (state: RootState): any | null => state.site.errors || null;

export const isBusySelector = (state: RootState): boolean => state.site.status === StoreStatus.BUSY;

export const responseSelector = (state: RootState): Site | null => state.site.response || null;

export const hasSuccessSelector = (state: RootState): boolean => (state.site.response ? true : false);
